import { render, staticRenderFns } from "./FileManagerSelect.vue?vue&type=template&id=cb230e36&scoped=true&"
import script from "./FileManagerSelect.vue?vue&type=script&lang=js&"
export * from "./FileManagerSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb230e36",
  null
  
)

export default component.exports